import { StyledHeader, StyledButton } from '@/components/styles'
import { Logo, MenuToggle, MobileNav, Language, ActiveLink, ContactWidget } from '@/components'
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import genLinkParams from '@/lib/generateLinkParams';
import { getLocaleFromPath, getPathnameOnly, getPublicPath, localizePath, stripLocaleFromPath } from '@/lib/locales'
import { getLocalizedRouteFromRouter } from '@/lib/localizedRouting'
import Icon from '@/assets/icons'
import noScroll from 'no-scroll'
import { useTranslation } from "react-i18next";

const languages = [{
  ind: 1,
  href: 'en',
  title: 'EN',
},
{
  ind: 2,
  href: 'ar',
  title: 'AR',
}]


export default function Header({ menu }) {
  const router = useRouter();
  const [mobileNavVisibility, setMobileNavVisiibility] = useState(false);
  const [searchHref, searchAs] = genLinkParams({ type: 'search' })
  const { t } = useTranslation("global");
  const { i18n } = useTranslation("global");
  const [current, setCurrent] = useState(() => getLocaleFromPath(router.asPath));

  const toggleMenuVisibility = (e) => {
    e.stopPropagation()
    setMobileNavVisiibility(!mobileNavVisibility)
    noScroll.toggle()
  }

  const changeLanguage = (lng) => {
    const { href, as } = getLocalizedRouteFromRouter(router, lng)

    i18n.changeLanguage(lng)
    setCurrent(lng)
    router.push(href, as)
  };

  useEffect(() => {
    const locale = getLocaleFromPath(getPublicPath(router.asPath))
    setCurrent(locale)

    if (i18n.language !== locale) {
      i18n.changeLanguage(locale)
    }
  }, [router.asPath, i18n])

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY
      const pageStart = scrollPos < 50

      if ((pageStart) && scrolled) {
        setScrolled(false)
      }
      if (!pageStart && !scrolled) {
        setScrolled(true)
      }
    }

    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [scrolled])

  return (
    <StyledHeader scrolled={scrolled}>
      <StyledHeader.Inner>
        <StyledHeader.Container>
          <StyledHeader.Toggle>
            <MenuToggle isOpen={mobileNavVisibility} onClick={toggleMenuVisibility} />
          </StyledHeader.Toggle>
          <StyledHeader.Logo scrolled={scrolled}>
            <Logo />
          </StyledHeader.Logo>
          <StyledHeader.Items>
            <StyledHeader.Address><a href="https://maps.app.goo.gl/a1kNeSsap6ANU7oN7">{t('contacts.address')}</a></StyledHeader.Address>
            <ContactWidget buttonAppearance={true} fixed={false} />
            <StyledButton light>{t('signIn')}</StyledButton>
          </StyledHeader.Items>
          <StyledHeader.Icons>
            <ActiveLink href={searchHref} as={searchAs}>
              <StyledHeader.Search>
                <Icon name="search" />
              </StyledHeader.Search>
            </ActiveLink>
            <StyledHeader.Account />
          </StyledHeader.Icons>

          <StyledHeader.Languages>
            {languages.map((item) => {
              const { ind, href, title } = item
              return <Language key={ind} href={href} title={title} current={current == href ? true : false}
                onClick={(e) => {
                  e.preventDefault();
                  changeLanguage(href);
                }
                } />
            })}
          </StyledHeader.Languages>
        </StyledHeader.Container>
      </StyledHeader.Inner>

      <MobileNav
        menu={menu}
        isOpen={mobileNavVisibility}
        toggleMenuVisibility={toggleMenuVisibility}
      />
    </StyledHeader>
  )
}
